module.exports = __webpack_public_path__ + "img/icon_sign_rules.2390820a.png";